import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconStyleEmbroidery';
/** Renders an SVG icon. */
const SvgStyleEmbroidery = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M9.632 28h5.734l-.25-2H9.882zM8.8 7a1 1 0 0 0-.98.802l-.015.094-1.578 15A1 1 0 0 0 7.22 24h10.556a1 1 0 0 0 .995-1.105l-1.578-15A1 1 0 0 0 16.198 7zM11 5h3V4h-3zm5 0h.198a3 3 0 0 1 2.984 2.686l1.579 15A3 3 0 0 1 17.778 26h-.646l.219 1.752.015.222a2 2 0 0 1-2 2.026H9.632a2 2 0 0 1-1.984-2.248L7.866 26h-.645a3 3 0 0 1-2.983-3.314l1.579-15 .043-.282A3 3 0 0 1 8.8 5H9V3.5A1.5 1.5 0 0 1 10.5 2h4A1.5 1.5 0 0 1 16 3.5zm7 22V12.74a2.07 2.07 0 0 1-1.07-1.666l-.321-4.507a2.397 2.397 0 1 1 4.78 0l-.321 4.507a2.07 2.07 0 0 1-1.069 1.666V27a1 1 0 1 1-2 0Zm1-21a.397.397 0 0 0-.396.425l.321 4.507a.074.074 0 0 0 .148 0l.322-4.507A.396.396 0 0 0 23.999 6Z"
      />
      <path
        fill="currentColor"
        d="m19.293 20.956-13 4-.588-1.912 13-4zm0-4-13 4-.588-1.912 13-4zm0-4-13 4-.588-1.912 13-4zm-.812-3.75-12.188 3.75-.588-1.912 12.188-3.75z"
      />
    </svg>
  );
};
SvgStyleEmbroidery.displayName = displayName;
export default SvgStyleEmbroidery;
